import { price } from '@/filters';
import { h } from 'vue';

export default {
  functional: true,
  props: ['product', 'person'],
  render() {
    return [
      h('div', [
        h('div', { class: 'label-group' }, [
          h('span', { class: 'label-heading' }, this.$t('purchase.product')),
          h('span', { class: 'label-text d-block' }, this.product.title),
        ]),
        h('div', { class: 'label-group' }, [
          h('span', { class: 'label-heading' }, this.$t('purchase.person')),
          h('span', { class: 'label-text d-block' }, `${this.person.name} ${this.person.personId}`.trim()),
        ]),
        h('div', { class: 'label-group' }, [
          h('span', { class: 'label-heading' }, this.$t('price')),
          h('span', { class: 'label-text d-block' }, price(this.product.price)),
        ]),
      ]),
      h('span', { class: `d-none d-sm-block purchase-icn ${this.product.icon}` }),
    ];
  },
};
